import { useTranslation } from "react-i18next";
import ToolTip, { IconType } from "../../../../../components/ToolTip";
import ConvertToString from "../../../../../components/Converter";
import { RowBody } from "../../../../../components/RowValue/RowBody";

export default function ModelFactor({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionTestLoads.modelFactor")}</p>}
      indicesValue={
        <span>
          η<sub>M</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(value, 2)}</span>}
      formulaValue={
        <ToolTip
          id={"modelFactorDIN"}
          type={IconType.INFO}
          text={t("lvText.positionTestLoads.modelFactorInfo")}
        />
      }
    />
  );
}
